import { Moment } from 'moment-timezone/moment-timezone'

/**
 * Decimal Hour of Day is the time of day expressed as a number of hours from midnight,
 * including the minutes as the fraction.
 *
 * For example:
 * 10     is 10am
 * 11.5   is 11:30am
 * 14     is 2pm
 * 15.25  is 3:15pm
 * 23+1/3 is 11:20pm
 *
 * TODO Come up with a better name than "Decimal Hour of Day".
 * TODO Would this be any simpler using a different unit? E.g. seconds, milliseconds, minutes or days?
 */

export function momentTo24hTime(moment: Moment): string {
  return moment.format('HHmm')
}

export function momentToDecimalHourOfDay(moment: Moment): number {
  const hour = moment.format('H')
  const minute = moment.format('mm')
  return Number(hour) + Number(minute) / 60
}

// TODO Look for a library that handles time-of-day (as distinct from date-time).
export function formatDecimalHour(decimal: number) {
  // Separate out hours and minutes.
  const hours = Math.floor(decimal)
  const minutes = 60 * (decimal % 1)

  // Calculate and format components.
  const h24 = twoDigits(hours)
  // '0' hours becomes '12' o clock in 12-hour time.
  const h12 = String(hours % 12 || 12)
  const am = decimal < 12 ? 'am' : 'pm'
  const m = twoDigits(minutes)

  // Build formatted times from components.
  const twelve = `${h12}:${m} ${am}`
  return {
    twelve,
    twentyFour: `${h24}${m}`,
    shortTwelve: minutes > 0 ? twelve : `${h12}${am}`,
  }
}

function twoDigits(number: number) {
  return String(number).padStart(2, '0')
}
